// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"54df87d3","977":"d81b1804"}[chunkId] + ".chunk.js";
};